import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useHLS } from "../../hooks/useHLS";
import { HlsContext } from ".";

export const HlsProvider = ({ children, Hls = {}, config = {} }) => {
  const { hls, removeHLS, setUpVideoSource } = useHLS(Hls, config);

  const contextValue = useMemo(
    () => ({
      isSupported:
        typeof Hls?.isSupported === "function" ? Hls.isSupported() : false,
      hls,
      removeHLS,
      setUpVideoSource
    }),
    [Hls, hls, removeHLS, setUpVideoSource]
  );

  return (
    <HlsContext.Provider value={contextValue}>{children}</HlsContext.Provider>
  );
};

HlsProvider.propTypes = {
  Hls: PropTypes.func,
  children: PropTypes.node,
  config: PropTypes.shape({
    hlsConfig: PropTypes.object,
    debug: PropTypes.bool,
    debugHLS: PropTypes.bool
  })
};
